/**
 *
 * SaveAsFavorite
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectAllowSignIn } from 'containers/Main/selectors';
import ReactTooltip from 'react-tooltip';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import SettingsIcon from '@material-ui/icons/Settings';
import Config from 'utils/getEnvConfig';
import ClassNames from 'classnames';
import HeartEmptyIcon from './images/heart-empty.svg';
import HeartFullIcon from './images/heart-full.svg';

const {
  CONTENTFUL: { SPACE_ID, ENVIRONMENT },
} = Config;

const styles = theme => ({
  btn: {
    width: '100%',
    margin: '6px 0',
    backgroundColor: 'white',
    height: 48,
    border: `1px solid #E3E3E3`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 30.5,
  },
  btnWithoutText: {
    padding: 0,
    fontSize: 15,
    marginRight: 16,
    color: theme.palette.text.primary,
    backgroundColor: 'transparent',
    '&:hover': {
      background: 'none',
    },
    border: 0,
    borderRadius: 0,
    [theme.breakpoints.down('xs')]: {
      marginRight: 0,
    },
  },
  withText: {
    marginRight: 10,
    [theme.breakpoints.down('880')]: {
      marginRight: 0,
    },
  },
  topicIcon: {
    width: 25,
  },
  settings: {
    fontSize: 30,
  },
  label: {
    textTransform: 'uppercase',
    marginLeft: 8,
  },
});

function SaveAsFavorite({
  allowSignIn,
  classes,
  id,
  isAdmin,
  saved,
  save,
  withText,
}) {
  if (!allowSignIn) return null;

  const label = saved ? 'Remove from Favorite' : 'Save as Favorite';
  return (
    <>
      <ReactTooltip
        id={`SaveAsFavorite-${id}`}
        place="top"
        type="light"
        border
        disable={withText}
      >
        {label}
      </ReactTooltip>
      <IconButton
        className={withText && classes.btn}
        classes={{ root: !withText && classes.btnWithoutText }}
        onClick={save}
        disableRipple
        data-tip
        data-for={`SaveAsFavorite-${id}`}
      >
        <img
          src={saved ? HeartFullIcon : HeartEmptyIcon}
          alt="Full"
          className={ClassNames(
            classes.topicIcon,
            withText ? classes.withText : undefined,
          )}
        />
        {withText && (
          <Typography
            variant="overline"
            color="textPrimary"
            component="span"
            className={classes.label}
          >
            {label}
          </Typography>
        )}
      </IconButton>
      {isAdmin && (
        <>
          <ReactTooltip
            id="contentful"
            place="top"
            type="light"
            border
            disable={withText}
          >
            See this entry on Contentful
          </ReactTooltip>
          <a
            href={`https://app.contentful.com/spaces/${SPACE_ID}/${
              ENVIRONMENT === 'master' ? '' : `environments/${ENVIRONMENT}/`
            }entries/${id}`}
            target="_blank"
            rel="noopener"
            style={
              withText
                ? { width: '100%', textDecoration: 'none' }
                : { display: 'inline-flex' }
            }
            data-tip
            data-for="contentful"
          >
            <IconButton
              classes={{
                root: withText ? classes.btn : classes.btnWithoutText,
              }}
              disableRipple
            >
              <SettingsIcon className={classes.settings} />
              {withText && (
                <Typography
                  variant="overline"
                  color="textPrimary"
                  component="span"
                  className={classes.label}
                >
                  See this entry on Contentful
                </Typography>
              )}
            </IconButton>
          </a>
        </>
      )}
    </>
  );
}

SaveAsFavorite.propTypes = {
  allowSignIn: PropTypes.bool,
  classes: PropTypes.object,
  id: PropTypes.string,
  isAdmin: PropTypes.bool,
  saved: PropTypes.bool,
  save: PropTypes.func,
  withText: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  allowSignIn: makeSelectAllowSignIn(),
});

const withConnect = connect(mapStateToProps);

export default compose(
  withStyles(styles),
  withConnect,
)(SaveAsFavorite);
